import { useState, useEffect } from "react";
import { Grid2, Typography, Button, Box, TextField } from "@mui/material";
import NumOtpStyles from "./SignUpEmailOtp.module.css";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { generateEmailOtp, setEmailStatus, verifyEmailOtp } from "../../../Redux/usersSlice";
import Logo from '../../../Assets/Images/logo.svg';
import EditIcon from '@mui/icons-material/Edit';
import collab from '../../../Assets/Images/collab1.svg';

export default function EmailNumOtp() {
  const [otp, setOtp] = useState("");
  const [localError, setLocalError] = useState("");
   const [timeLeft, setTimeLeft] = useState(20); // ⏳ 600 seconds countdown

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, userData,source } = useSelector(state => state.user);

  // Get email and mobile from userData
  const email = userData?.email.toLowerCase();
  const mobile = userData?.mobile;

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "email_otp_page_viewed",
      page_path: window.location.pathname
    });
  }, []);

   // ⏳ Countdown Timer
  useEffect(() => {
    if (timeLeft <= 0) return; // stop if expired
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // cleanup
  }, [timeLeft]);

  // Redirect logic
  useEffect(() => {
    if (!email) {
      navigate('/signupemail');
      return;
    }

    if (userData?.steps?.["Email Verify"]?.status) {
      navigate('/signupcongrats');
    }
  }, [userData, email, navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 1) {
      const newOtp = otp.split("");
      newOtp[index] = value;
      const updatedOtp = newOtp.join("")
      setOtp(updatedOtp);
      setLocalError("");

      if (value && index < 3) { // Changed to 3 since we have 4 inputs (0-3)
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }

       if (updatedOtp.length === 4) {
        console.log("OTP entered:", updatedOtp);
        handleOtpSubmit(updatedOtp); // Call API here
      }
    }
  };

  

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleOtpSubmit = async (updatedOtp) => {
    // e.preventDefault();

    // Client-side validation
    if (updatedOtp.length !== 4) {
      setLocalError("Please enter a 4-digit OTP");
      return;
    }

    const parsedOtp = parseInt(updatedOtp, 10);
    if (isNaN(parsedOtp)) {
      setLocalError("OTP must contain only numbers");
      return;
    }

    if (!email || !mobile) {
      setLocalError("Email or mobile not found");
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "email_otp_entered",
      page_path: window.location.pathname
    });

    try {
      const response =await dispatch(verifyEmailOtp({ 
        mobile, 
        email, 
        otp: parsedOtp 
      })).unwrap();

      if(response?.data?.data?.success){
        dispatch(setEmailStatus())
       
      } else if (response?.data?.data?.message === "Please provide valid email or otp") {
        setLocalError("Please provide valid email or otp")
        // Navigation will be handled by useEffect
      } else if (response?.data?.data?.message === "Invalid otp") {
        setLocalError("Invalid otp")
      } else if (response.data?.data?.message === "OTP expired, please request a new one") {
        setLocalError("OTP expired, please request a new one")
      }
  
  } catch (error) {
      console.error('Email OTP verification failed:', error);
      setLocalError(error?.data?.data?.message)
    }
  };

  const handleResendEmailOtp=async(e)=>{
    e.preventDefault();

    try {
          const response = await dispatch(generateEmailOtp({ mobile, email ,referral_code: localStorage.getItem("refCode") || ""})).unwrap();
          
    
          if (response?.data?.data?.success) {
            // Reset timer and clear any old error
            setTimeLeft(20);
            setLocalError("");
    
            // Update userData if backend sends updated user object
            // if (response.data?.user) {
            //   dispatch(setuserData(response.data?.user));
            // }
    
          } else if (response.data?.message) {
            setLocalError(response.data.message);
          }
    
        } catch (error) {
          console.error("Resend OTP failed:", error);
          setLocalError(error?.data?.data?.message || "Something went wrong, please try again");
        }

  }

  return (
    <main>
    <Grid2
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        "@media (max-width:600px)": {
          justifyContent: "start"
        }
      }}
    >
      <Grid2 className={NumOtpStyles.content_wrapper}>
        <img
          src={source == "cosmos" ? collab : Logo}
          alt="Logo"
          className={source == "cosmos" ? NumOtpStyles.twologo : NumOtpStyles.nav_logo}
        />
        {
          source == "cosmos" &&
          <Typography className={NumOtpStyles.txt}>
            Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
          </Typography>
        }
        <Typography className={NumOtpStyles.heading}>OTP</Typography>
        <Typography className={NumOtpStyles.sub_title}>
          Enter OTP sent to {email} <EditIcon
              sx={{
                fontSize: {
                  xs: "15px", // small screens (mobile)
                  sm: "20px", // tablets
                  md: "22px", // medium laptops
                  lg: "24px", // large desktops
                },
                ml:"6px",
                color: "#1565c0",
                cursor: "pointer",
                "&:hover": { color: "blue" },
              }}
               onClick={() => navigate("/signupemail")} // 👉 add your edit action here
            />
        </Typography>

        <form autoComplete="off">
          {/* Hidden dummy fields to block Chrome/Safari autofill */}
          <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
          <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />

        <Box className={NumOtpStyles.otp_container}>
          {[...Array(4)].map((_, index) => (
            <TextField
              key={index}
              id={`otp-${index}`}
              value={otp[index] || ""}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                className: NumOtpStyles.otp_input,
                type: "tel",
                inputMode: "numeric",
                "aria-label": `OTP digit ${index + 1}`,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  bgcolor: "white",
                  width: "94px",
                  height: "75px",
                  borderColor: "#ABABAB80 !important",
                  "& fieldset": {
                    borderColor: "#ABABAB80",
                  },
                  "&:hover fieldset": {
                    borderColor: "#ABABAB80 !important",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#ABABAB80 !important",
                  },
                  "@media (max-width: 550px)": {
                    width: "80px",
                    height: "65px"
                  },
                  "@media (max-width: 480px)": {
                    width: "70px",
                    height: "60px"
                  },

                  "@media (max-width: 420px)": {
                    width: "60px",
                    height: "50px"
                  },
                  "@media (max-width: 360px)": {
                    width: "55px",
                    height: "42px"
                  },
                },
              }}
            />
          ))}
        </Box>
     </form>
        {/* Show local errors first, then Redux errors */}
        {localError && (
          <Typography color="error" sx={{ marginTop: "10px" }}>
            {localError}
          </Typography>
        )}

         {/* ⏳ Show Timer */}
          <Typography
            sx={{
              marginTop: "15px",
              fontWeight: 500,
              fontSize: "18px", // default (desktop)
              fontFamily:"Inter400 !important",
              textAlign: "center",
              "@media (max-width:600px)": {
                fontSize: "16px",
              },
              "@media (max-width:480px)": {
                fontSize: "14px",
              },
              "@media (max-width:360px)": {
                fontSize: "12px",
              },
            }}
          >
            {timeLeft > 0
              ? `Resend OTP in ${String(Math.floor(timeLeft / 60)).padStart(2, "0")}:${String(timeLeft % 60).padStart(2, "0")}`
            : <Button onClick={handleResendEmailOtp} sx={{ textTransform: "Capitalize !important", fontFamily: "Inter400 !important", fontSize: "18px", color:"#000000" }}>Resend Otp</Button>}
          </Typography>
  

        <Grid2 className={NumOtpStyles.button_card}>
          <Button 
            className={NumOtpStyles.button} 
            onClick={handleOtpSubmit}
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Proceed'}
          </Button>
        </Grid2>
      </Grid2>
    </Grid2>
    </main>
  );
}